import React from "react";
import { Alert, Box, Button } from "@mui/material";

const recarregarPagina = () => window.location.reload();

// Cada navegador descreve de um jeito a falha do import() dinâmico (arquivo do
// chunk que não existe mais ou rede fora).
const FALHA_DE_CHUNK =
  /dynamically imported module|importing a module script failed|loading (css )?chunk/i;

const ehFalhaDeChunk = (erro) =>
  FALHA_DE_CHUNK.test(`${erro?.name ?? ""} ${erro?.message ?? ""}`);

// Rede de proteção do carregamento por rota: o código de cada tela é baixado sob
// demanda, e depois de um deploy os arquivos da versão anterior deixam de existir,
// então abrir uma rota numa aba antiga falha. Sem isto a tela inteira ficaria em
// branco; aqui o usuário vê o aviso e recarrega para pegar a versão nova.
//
// Só a falha de chunk é apresentada como "versão nova"; qualquer outro erro de
// renderização de uma página ganha uma mensagem genérica (e continua indo para o
// console pelo React), para não mandar o usuário recarregar por um bug que o
// recarregamento não resolve.
//
// `resetKey` é a rota atual: ao navegar para outra, o erro é limpo e a nova rota
// é renderizada (o menu continua funcionando). O `React.lazy` guarda a rejeição do
// import, então a MESMA rota que falhou segue falhando até recarregar a página.
class ErroDeCarregamento extends React.Component {
  state = { erro: null, chave: this.props.resetKey };

  static getDerivedStateFromError(erro) {
    return { erro };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.resetKey !== state.chave) {
      return { erro: null, chave: props.resetKey };
    }
    return null;
  }

  render() {
    if (!this.state.erro) {
      return this.props.children;
    }

    const { onRecarregar = recarregarPagina } = this.props;

    return (
      <Box sx={{ p: 3 }}>
        <Alert
          severity="error"
          action={
            <Button color="inherit" size="small" onClick={onRecarregar}>
              Recarregar
            </Button>
          }
        >
          {ehFalhaDeChunk(this.state.erro)
            ? "Não foi possível carregar esta tela. Pode haver uma versão nova do sistema: recarregue a página."
            : "Ocorreu um erro ao exibir esta tela. Tente recarregar a página; se continuar, avise o suporte."}
        </Alert>
      </Box>
    );
  }
}

export default ErroDeCarregamento;
